import React from 'react';
interface UspsBadgeProps {
  /** Extra line shown after the carrier name, e.g. "Free U.S. shipping." */
  note?: string;
  className?: string;
}
const EAGLE_SRC = 'https://cdn.magicpatterns.com/patterns/generated-images/83e88552-a8ae-4731-8bd6-008cda500f30.jpg';
const USPS_BLUE = '#1C6EB4';

/**
 * USPS carrier lockup: the eagle head mark beside the United States Postal
 * Service wordmark in USPS blue.
 */
export function UspsMark({
  className = 'h-6'
}: {
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-2 ${className}`} data-id="element-892" data-mp="1ico0u3pwm50w">
      <img src={EAGLE_SRC} alt="" aria-hidden="true" className="h-full w-auto object-contain" style={{
      mixBlendMode: 'multiply'
    }} data-id="element-893" data-mp="1ibcx23wgkx9s" />
      <span className="flex flex-col justify-center leading-[1.05]" data-id="element-894" data-mp="19ecdcakc3nco">
        <span className="text-[0.42em] font-bold uppercase tracking-[0.04em]" style={{
        color: USPS_BLUE,
        fontFamily: 'Helvetica, Arial, sans-serif'
      }} data-id="element-895" data-mp="14cdb540bywhb">
          United States
        </span>
        <span className="text-[0.42em] font-bold uppercase tracking-[0.04em]" style={{
        color: USPS_BLUE,
        fontFamily: 'Helvetica, Arial, sans-serif'
      }} data-id="element-896" data-mp="335xfk1ybcsh9">
          Postal Service<sup className="text-[0.5em] align-super" data-id="element-897" data-mp="2tavpn3w7rmdm">®</sup>
        </span>
      </span>
    </span>;
}
export function UspsBadge({
  note,
  className = ''
}: UspsBadgeProps) {
  return <div className={`flex flex-wrap items-center gap-x-3 gap-y-2 ${className}`} data-id="element-898" data-mp="3lz16hfk5cr86">
      <span className="inline-flex items-center bg-white px-2.5 py-1.5" aria-label="United States Postal Service" data-id="element-899" data-mp="3qxcju09nhjv5">
        <UspsMark className="h-7 text-[28px] sm:h-8 sm:text-[32px]" data-id="element-900" data-mp="3bysbu65szduw" />
      </span>
      <span className="text-xs font-semibold uppercase tracking-wide text-steel-300" data-id="element-901" data-mp="3gy3tdhdzundj">
        Shipped USPS, insured and tracked{note ? ` · ${note}` : ''}
      </span>
    </div>;
}